import * as React from 'react';

export const dzFlagContent: JSX.Element = (
    <>
        <g clip-path='url(#clip0_55_3140)'>
            <rect
                width='28'
                height='20'
                rx='4'
                fill='#F7FCFF'
            />
            <mask
                id='mask0_55_3140'
                style={{ maskType: 'alpha' }}
                maskUnits='userSpaceOnUse'
                x='0'
                y='0'
                width='28'
                height='20'
            >
                <path
                    d='M0 4C0 1.79086 1.79086 0 4 0H24C26.2091 0 28 1.79086 28 4V16C28 18.2091 26.2091 20 24 20H4C1.79086 20 0 18.2091 0 16V4Z'
                    fill='#D9D9D9'
                />
            </mask>
            <g mask='url(#mask0_55_3140)'>
                <path
                    d='M0 0H14V20H0V0Z'
                    fill-rule='evenodd'
                    clip-rule='evenodd'
                    fill='#36A400'
                />
                <path
                    d='M14.2686 4C16.2603 4.00005 18.0343 4.89026 19.1826 6.27637C18.2764 5.52074 17.0922 5.06254 15.7959 5.0625C12.9467 5.06256 10.6368 7.273 10.6367 10C10.6369 12.7269 12.9468 14.9384 15.7959 14.9385C17.0924 14.9384 18.2763 14.4786 19.1826 13.7227C18.0344 15.1091 16.2606 15.9999 14.2686 16C10.8066 15.9998 8.00019 13.3135 8 10C8.00009 6.68641 10.8065 4.00022 14.2686 4ZM18.0459 9.39062L20 10.0596L18.0459 10.8613V12.9346L16.8506 11.1484L14.6641 11.9023L15.8193 10.0596L14.6641 8.33008L16.749 8.87988L18.2002 7.30469L18.0459 9.39062Z'
                    fill='#FF0000'
                />
            </g>
        </g>
        <defs>
            <clipPath id='clip0_55_3140'>
                <rect
                    width='28'
                    height='20'
                    rx='4'
                    fill='white'
                />
            </clipPath>
        </defs>
    </>
);
